import { FormattedMessage } from 'react-intl'
import { WorkspaceAlertWithLogout } from './WorkspaceAlertWithLogout'

export const NoActiveWorkspaceAlert = () => {
  return (
    <WorkspaceAlertWithLogout
      message={<FormattedMessage id="workspace.noActiveMembership" />}
    />
  )
}
